import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { StoreService } from 'core/services/store.service';
import { Subscription } from 'rxjs';

// TODO this component maintains compatibility with admin tables and skeletor tables using the "skeletor" attribute, delete when not needed

@Component({
  selector: 'lms-list-counter',
  templateUrl: './list-counter.component.html',
  styleUrls: ['./list-counter.component.scss']
})
export class ListCounterComponent implements OnInit, OnDestroy {
  @Input() listId: string;
  @Input() skeletor: boolean = false; // TODO flag to maintain compatibility true for skeletor table false for admin old ones
  public listSubscription: Subscription;
  total: number;

  constructor(public translate: TranslateService) {}

  ngOnInit() {
    this.listSubscription = StoreService.get(this.listId).subscribe((data) => {
      const { total = 0 } = data || {};
      this.total = total;
    });
  }

  ngOnDestroy() {
    this.listSubscription.unsubscribe();
  }
}
